export class LoadOrderValidationError extends Error {
    mValidationRes;
    mLoadOrder;
    constructor(validationRes, loadOrder) {
        super("Invalid Load Order");
        this.name = "LoadOrderValidationError";
        this.mValidationRes = validationRes;
        this.mLoadOrder = loadOrder;
    }
    get validationResult() {
        return this.mValidationRes;
    }
    get loadOrder() {
        return this.mLoadOrder;
    }
    get loadOrderEntryNames() {
        const lo = this.mLoadOrder
            .filter((entry) => !!entry)
            .map((entry) => entry.name)
            .join("\n");
        return lo;
    }
}
export class LoadOrderSerializationError extends Error {
    mLoadOrder;
    constructor(loadOrder) {
        super("Failed to serialize load order");
        this.name = "LoadOrderSerializationError";
        this.mLoadOrder = loadOrder.map((entry) => entry.name);
    }
    get loadOrder() {
        return this.mLoadOrder.join("\n");
    }
}
